import React, { useContext } from 'react'

import {motion} from 'framer-motion'

import useFirestore from '../../../hooks/useFirestore'
import StateContext from '../../../StateContext'
import { firestore } from '../../../firebase'

import './Gallery.css'

function ImageGrid({setSelectedImg, setShowImage}) {

    const appState = useContext(StateContext)

    const { docs } = useFirestore('images')

    async function deleteHandler(e, imageId) {
        e.preventDefault()
        try {
            const imageRef = firestore.collection("images").doc(imageId)
            imageRef.delete()
        } catch (error) {
            
        }

    }

    function clickHandler(imageUrl) {
        setSelectedImg(imageUrl);
        setShowImage && setShowImage(false);
    }

    return (
        <div className="img-grid">
            {docs && docs.map((doc, index) => {
                return (
                    <motion.div 
                        className="image-wrap" 
                        key={index} 
                        onClick={() => clickHandler(doc.imageUrl)}
                        layout
                        whileHover={{ opacity: 1 }}
                    >
                        <motion.img 
                            className="player-image"
                            src={doc.imageUrl} 
                            alt={doc.imageUrl}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }} 
                            transition={{ delay: 1 }}
                        />
                        {appState.loggedIn && (
                            <div>
                                <button onClick={e => deleteHandler(e, doc.id)} className="btn btn-sm btn-danger">
                                    <i className="fas fa-trash"></i> Slett bilde
                                </button>
                            </div>
                        )}
                    </motion.div>
                )
            })}
        </div>
    )
}
export default ImageGrid